<template>
  <body>
    <div class="contact-info-container">
      <div class="container">
        <div class="row contact-info">
          <h2 class="contact-text">
            email: nathan.mccloud898@gmail.com
          </h2>
        </div>
        <div class="row contact-info">
          <h2 class="contact-text">
            {{ phoneInfo }}
          </h2>
        </div>
      </div>
      <form
        method="POST"
        name="contact"
        netlify
        @submit.prevent="submitUserMessage"
      >
        <input
          type="hidden"
          name="form-name"
          value="contact"
        >
        <div class="msg-area">
          <h2>Or send me a message directly</h2>
          <textarea
            v-model="userText"
            class="contact-form"
            rows="5"
            cols="50"
            name="user-text"
          />
          <h2
            :style="sendMessageResponseStyle"
          >
            {{ sendMessageResponse }}          
          </h2>
        </div>
        <h2>
          <button
            type="submit"
            class="send-button"
          >
            Send
          </button>
        </h2>
      </form>
    </div>
  </body>
</template>

<script>

export default {
  name: 'Contact',
  data() {
    return {
      userText: "",
      emptyMessageSubmitAttempted: false,
      messageSentSuccessfully: false,
      phoneInfo: 'phone:\n 217-552-9371',
      showRateLimitErrorMessage: false
    }
  },
  computed: {
    sendMessageResponse() {
      if(this.emptyMessageSubmitAttempted)
        return "Please enter a message";
      else if(this.showRateLimitErrorMessage)
        return "Please wait a bit and try again";
      else if(this.messageSentSuccessfully)
        return "Sent!";
      else return "''"; 
    },
     sendMessageResponseStyle() {
      return {
          'visibility': (this.emptyMessageSubmitAttempted || this.messageSentSuccessfully || this.showRateLimitErrorMessage) ? 'visible' : 'hidden',
          'color': (this.emptyMessageSubmitAttempted || this.showRateLimitErrorMessage) ? 'red' : 'lime'
      }
      }
  },
  methods: {
    async submitUserMessage($event) {
      const form = $event.target;
      const body = new URLSearchParams(new FormData(form));
      if(this.userText.trim().length === 0)
      {
        this.emptyMessageSubmitAttempted = true;
      }  
      else {
        try {
          const res = await fetch(form.action, { method: 'POST', body});
          if(res.status === 200) {
            this.messageSentSuccessfully = true;
            this.userText = "";
          }
          if(res.status === 429) {
            this.showRateLimitErrorMessage = true;
          }
          } catch(err) {console.log(err)
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$xs: 490px;
$sm: 540px;
$md: 720px;
$lg: 960px;
$xl: 1140px;

.contact-info {
  word-break: break-all;
  margin-left: 10px;
}

.contact-form {
  width: 75%;
  height: 20vh;
  max-width: 95%;
  max-height: 25vh;
  @media(max-width: $md) {
    max-height: 20vh;
  }
  resize: both;
  font-size: 2rem;
  font-family: 'Russo One', sans-serif;
}

.msg-area {
  margin-top: 2.5rem;
}

.msg-area h2 {
  font-size: 1rem;;
}

h1, h3 {
  font-family: 'Russo One', sans-serif;
  text-align: center;
}

h2 {
  font-family: 'Russo One', sans-serif;
}

h3 {
  font-size: 1.75rem;
  @media screen and (max-width: $md) {
    font-size: inherit;
  }
}

h5 {
  font-size: 1rem;
  margin-top: 6rem;
}

.break {
  height: .5em;
  width: 90%;
  @include hr-outline;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

#enter {
  margin-top: 1.25rem;
}

ul {
  list-style-type: none;
}

li > h2 {
  text-align: left;
}

.send-button {
  color: white;
  border-color: white;//rgb(35, 35, 252);
  box-shadow: 0px 2px rgba(190, 36, 190, 0.5);
  background-color: black;
  @media(min-width: $md) { 
    margin-bottom: 1.5rem;
  }
}

.send-button:hover {
  filter: brightness(60%);
}

.home-button {
  margin-top: 7rem;
}

.contact-text {
  @media (max-width: $md) {
    font-size: 1.5rem; 
  }
  @media (max-width: $xs) {
    font-size: 1rem;
    // margin-left: 1rem;
  }
}

.contact-info-container {
  background-color: black;
  width: 90%;
  margin-left: 5%;
  margin-top: .5rem;
  border: 2px dashed rgb(33, 37, 41);
  // max-height: fit-content;
}

</style>
